import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import clsx from 'clsx';
import Icon from '../Icon';

interface TopMenuUspsProps {
  uspList: Usp[];
  textColor: string;
}

interface Usp {
  uspText: string;
  uspLink?: string;
}

const TopMenuUsps = ({ uspList, textColor }: TopMenuUspsProps) => {
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    setHasLoaded(true);
  }, []);

  return (
    <>
      {uspList != undefined && uspList.length == 1 && (
        <div className="flex items-center justify-center">
          <a
            style={{ color: textColor }}
            className="flex items-center text-sm leading-normal"
            href={uspList[0]?.uspLink}
          >
            <span className="inline-flex items-center">
              <span className="relative">
                {uspList[0]?.uspText}
                {uspList[0]?.uspLink && (
                  <Icon
                    style={{ color: textColor }}
                    className="icon absolute -right-4 top-[3px] h-3 w-3 transition-all ease-in-out group-hover:-right-5"
                    name="arrow-right"
                  />
                )}
              </span>
            </span>
          </a>
        </div>
      )}
      {!hasLoaded && uspList != undefined && uspList.length > 1 && (
        <div className="flex items-center justify-center">
          <a
            style={{ color: textColor }}
            className="flex items-center text-sm leading-normal"
            href={uspList[0]?.uspLink}
          >
            <span className="inline-flex items-center">
              <span className="relative">
                {uspList[0]?.uspText}
                {uspList[0]?.uspLink && (
                  <Icon
                    style={{ color: textColor }}
                    className="icon absolute -right-4 top-[3px] h-3 w-3 transition-all ease-in-out group-hover:-right-5"
                    name="arrow-right"
                  />
                )}
              </span>
            </span>
          </a>
        </div>
      )}
      {hasLoaded && uspList.length > 1 && (
        <Swiper
          className="flex h-[18px] items-center justify-center text-center"
          modules={[Autoplay]}
          direction={'vertical'}
          loop={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          threshold={5}
        >
          {uspList.map((usp, idx) => (
            <SwiperSlide key={'slide' + idx}>
              <div className="flex h-full items-center justify-center">
                <a
                  style={{ color: textColor }}
                  className={clsx(
                    'group cursor-default text-center text-sm leading-normal',
                    usp.uspLink && 'hover:cursor-pointer'
                  )}
                  href={usp.uspLink}
                >
                  <span className="relative inline-flex items-center">
                    {usp.uspText}
                    {usp.uspLink && (
                      <span>
                        <Icon
                          style={{ color: textColor }}
                          className="icon absolute -right-4 top-[3px] h-3 w-3 transition-all ease-in-out group-hover:-right-5"
                          name="arrow-right"
                        />
                      </span>
                    )}
                  </span>
                </a>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </>
  );
};

export default TopMenuUsps;
